'use client';

import { c as _c } from "react/compiler-runtime";
import { dynamicWithRetry } from '@cc-shopping/utils/dynamic/dynamicWithRetry';
import type { CardSelectionModalProps } from 'src/features/compare-bar/CompareBar/CardSelectionModal';
import type { DesktopCompareBarProps } from 'src/features/compare-bar/CompareBar/DesktopCompareBar';
import type { MobileCompareBarProps } from 'src/features/compare-bar/CompareBar/MobileCompareBar';
import { useCompareBarAnalyticsEvents } from 'src/features/compare-bar/CompareBar/useCompareBarAnalyticsEvents';
const CardSelectionModal = dynamicWithRetry<CardSelectionModalProps>(() => import('src/features/compare-bar/CompareBar/CardSelectionModal').then(mod => ({
  default: mod.CardSelectionModal
})), {
  componentName: 'CardSelectionModal',
  ssr: false
});
const DesktopCompareBar = dynamicWithRetry<DesktopCompareBarProps>(() => import('src/features/compare-bar/CompareBar/DesktopCompareBar').then(mod => ({
  default: mod.DesktopCompareBar
})), {
  componentName: 'DesktopCompareBar',
  ssr: false
});
const MobileCompareBar = dynamicWithRetry<MobileCompareBarProps>(() => import('src/features/compare-bar/CompareBar/MobileCompareBar').then(mod => ({
  default: mod.MobileCompareBar
})), {
  componentName: 'MobileCompareBar',
  ssr: false
});
export function CompareBarSection() {
  const $ = _c(2);
  const compareBarAnalyticsEvents = useCompareBarAnalyticsEvents();
  let t0;
  if ($[0] !== compareBarAnalyticsEvents) {
    t0 = <><MobileCompareBar fireAnalyticsEvents={compareBarAnalyticsEvents} /><DesktopCompareBar fireAnalyticsEvents={compareBarAnalyticsEvents} /><CardSelectionModal fireAnalyticsEvents={compareBarAnalyticsEvents} /></>;
    $[0] = compareBarAnalyticsEvents;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}